module.exports = __webpack_public_path__ + "static/media/icon-ticket.d8c03feb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/TicketIcon/icon-ticket.svg
// module id = 1423
// module chunks = 1